import { render, staticRenderFns } from "./LandingList.vue?vue&type=template&id=d4f94b86&"
import script from "./LandingList.vue?vue&type=script&lang=js&"
export * from "./LandingList.vue?vue&type=script&lang=js&"
import style0 from "./LandingList.vue?vue&type=style&index=0&id=d4f94b86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports